import { useMutation } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useCreateDocumentCsvExport = (matterId: string) => {
  const { getFetchConfig } = useGetFetchConfig();

  return useMutation(
    async () => {
      const response = await fetch(
        `${APIBaseChronos}/api/matters/${matterId}/docs/export-csv`,
        getFetchConfig({ method: FetchMethod.POST }),
      );

      if (!response.ok) {
        throw new Error('Failed to start CSV export');
      }

      return (await response.json()) as { exportId: string };
    },
    {
      onError: () => {
        toast.error('Failed to start CSV export. Please try again.');
      },
    },
  );
};

export const useDownloadDocumentCsvExport = (matterId: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useMutation(
    async (exportId: string) => {
      const response = await fetch(
        `${APIBaseChronos}/api/matters/${matterId}/docs/export-csv/${exportId}/download`,
        fetchConfigGET,
      );

      if (!response.ok) {
        throw new Error('Failed to get download URL for document CSV export');
      }

      const { downloadUrl } = await response.json();

      const link = Object.assign(document.createElement('a'), {
        href: downloadUrl,
        download: 'Documents.csv',
      });
      link.click();
    },
    {
      onError: () => {
        toast.error('Failed to download CSV for document CSV export. Please try again.');
      },
    },
  );
};
